import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ResendPaymentLinkModal = ({ show, onClose, onResendPaymentLink, loading }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Reenviar link de pago')} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">{t('Confirma que quieres reenviar el email con el link de pago al cliente')}</Text>
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={onResendPaymentLink}
            defaultLabel={t('Enviar email')}
            loadingLabel={t('Enviar email')}
            loading={loading}
            disabled={loading}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default ResendPaymentLinkModal
